import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Capacitor } from '@capacitor/core';

const APPSTORE_URL =
  'https://apps.apple.com/us/app/blitz-pay-create-collaborate/id6747291851';
const DISMISS_KEY = 'blitz-ios-appstore-prompt-dismissed';

/* ───────────────────────── helpers ───────────────────────── */
const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);
const isRunningStandalone = () => window.navigator.standalone === true;

/** True when we’re in Safari / PWA on iOS *but not* the native Capacitor shell */
const shouldShowPrompt = () =>
  isIOS() &&
  Capacitor.getPlatform() === 'web' && // browser, not native wrapper
  !Capacitor.isNativePlatform?.() &&
  !isRunningStandalone();

/* ───────────────────────── component ─────────────────────── */
export default function AppStorePrompt() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(DISMISS_KEY);
    if (!seen && shouldShowPrompt()) {
      // wait a moment so it isn’t jarring
      const t = setTimeout(() => setOpen(true), 2000);
      return () => clearTimeout(t);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setOpen(false);
  };

  const handleVisitStore = () => {
    window.open(APPSTORE_URL, '_blank', 'noopener,noreferrer');
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ pr: 5 }}>
        Get Blitz on the App Store
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Typography>
          Enjoy a faster, smoother Blitz experience by installing our native
          iOS app.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Maybe later</Button>
        <Button variant="contained" onClick={handleVisitStore}>
          View in App Store
        </Button>
      </DialogActions>
    </Dialog>
  );
}
